import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { formatRut, validEmail, validRut } from "@/lib/format";

const FIELDS = [
  ["nombre", "Nombre"], ["apellido", "Apellido"], ["rut", "RUT", "12.345.678-9"], ["telefono", "Teléfono / WhatsApp", "+56 9 1234 5678"],
  ["email", "Correo electrónico", "tu@correo.cl"], ["direccion", "Dirección"], ["comuna", "Comuna"], ["ciudad", "Ciudad"],
];

export function customerErrors(c) {
  const e = {};
  FIELDS.forEach(([k]) => { if (!(c[k] || "").trim()) e[k] = "Obligatorio"; });
  if (c.rut && !validRut(c.rut)) e.rut = "RUT inválido";
  if (c.email && !validEmail(c.email)) e.email = "Correo inválido";
  if (c.telefono && (c.telefono.match(/\d/g) || []).length < 8) e.telefono = "Teléfono inválido";
  return e;
}

export function StepCustomer({ customer, setCustomer, accept, setAccept, policies, showErrors }) {
  const errs = showErrors ? customerErrors(customer) : {};
  const set = (k, v) => setCustomer((c) => ({ ...c, [k]: v }));
  return (
    <div data-testid="step-customer">
      <div className="grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, l, ph]) => (
          <div key={k} className={k === "direccion" ? "sm:col-span-2" : ""}>
            <Label htmlFor={`c-${k}`} className="text-sm">{l} *</Label>
            <Input id={`c-${k}`} data-testid={`customer-${k}-input`} value={customer[k] || ""} placeholder={ph}
              type={k === "email" ? "email" : k === "telefono" ? "tel" : "text"}
              onChange={(e) => set(k, e.target.value)}
              onBlur={k === "rut" ? () => customer.rut && set("rut", formatRut(customer.rut)) : undefined}
              className={`mt-1.5 h-12 rounded-xl bg-white ${errs[k] ? "border-red-500" : ""}`} />
            {errs[k] && <p className="mt-1 text-xs text-red-600" data-testid={`customer-${k}-error`}>{errs[k]}</p>}
          </div>
        ))}
        <div className="sm:col-span-2">
          <Label htmlFor="c-obs" className="text-sm">Observaciones (opcional)</Label>
          <Textarea id="c-obs" data-testid="customer-observaciones-input" value={customer.observaciones || ""}
            onChange={(e) => set("observaciones", e.target.value)} className="mt-1.5 rounded-xl bg-white" rows={3} />
        </div>
      </div>
      <label className={`mt-6 flex items-start gap-3 rounded-2xl border p-4 bg-white ${showErrors && !accept ? "border-red-500" : "border-border"}`}>
        <Checkbox checked={accept} onCheckedChange={(v) => setAccept(!!v)} data-testid="accept-terms-checkbox" className="mt-0.5" />
        <span className="text-sm leading-relaxed">
          Acepto los términos y condiciones, la política de cambios y la política de privacidad.{" "}
          <Dialog>
            <DialogTrigger asChild>
              <button type="button" className="font-semibold text-[#5E6B52] underline" data-testid="view-policies-btn">Ver políticas</button>
            </DialogTrigger>
            <DialogContent className="max-w-lg">
              <DialogHeader><DialogTitle className="font-serif">Políticas de Rachel Lodge</DialogTitle></DialogHeader>
              <div className="space-y-3 text-sm leading-relaxed max-h-[60vh] overflow-y-auto">
                <p className="whitespace-pre-line">{policies?.text}</p>
                {policies?.change_deadline_days > 0 && <p>Cambios de fecha con al menos {policies.change_deadline_days} días de anticipación, sujetos a disponibilidad y aprobación.</p>}
                <p className="whitespace-pre-line">{policies?.terms_text}</p>
                <p className="whitespace-pre-line">{policies?.privacy_text}</p>
              </div>
            </DialogContent>
          </Dialog>
        </span>
      </label>
    </div>
  );
}
